import type { Exercise, Question, ReadingBlock, ReadingSection, Source } from '../types.ts';

export const section = (
  id: string,
  title: string,
  text: string | (string | ReadingBlock)[],
  role?: ReadingSection['role'],
): ReadingSection => ({
  id,
  title,
  blocks: (typeof text === 'string' ? text.trim().split(/\n\s*\n/) : text).map((item) =>
    typeof item === 'string' ? { kind: 'paragraph', text: item } : item,
  ),
  ...(role ? { role } : {}),
});
export const source = (title: string, url: string): Source => ({ title, url });
export function choice(
  id: string,
  prompt: string,
  options: string[],
  correct: number,
  explanation: string,
  sectionIds: string[],
): Question {
  return {
    id,
    prompt,
    options: options.map((text, i) => ({ id: String(i), text })),
    answer: { kind: 'choice', value: String(correct) },
    explanation,
    sectionIds,
    evidence: explanation,
  };
}
export function number(
  id: string,
  prompt: string,
  value: number,
  unit: string,
  explanation: string,
  sectionIds: string[],
  tolerance = 0.0001,
): Question {
  return {
    id,
    prompt,
    answer: { kind: 'number', value, tolerance, unit },
    explanation,
    sectionIds,
    evidence: explanation,
  };
}
export function exercise(
  value: Omit<Exercise, 'reading'> & { reading: Omit<Exercise['reading'], 'authorship'> },
): Exercise {
  return {
    ...value,
    reading: {
      ...value.reading,
      authorship: 'Original explanations prepared with AI assistance. References are listed below.',
    },
  };
}
